import Vue from 'vue'
import Router from 'vue-router'
import DocumentResultView from '@/views/DocumentResultView'

import MainLayout from '@/layouts/MainLayout'

import Login from '@/views/Login'
import KeyAPI from '@/components/UserProfile/KeyAPI'
import UserInformation from '@/components/UserProfile/UserInformation'
import Security from '@/components/UserProfile/Security'
import Register from '@/views/Register'
import UserProfileView from '@/views/user/UserProfileView'
import ForgotPassword from '@/views/ForgotPassword'
import ResetPassword from '@/views/ResetPassword'
import ConfirmRegistration from '@/views/ConfirmRegistration'
import ResendConfirmRegistration from '@/views/ResendConfirmRegistration'
import Dashboard from '@/views/Dashboard'
import DocumentManagement from '@/views/admin/DocumentManagement'
import AdminUserManagement from '@/views/admin/AdminUserManagement'
import {RouteNames} from '@/constants/DoITConstant'
import RootDashboard from '@/views/RootDashboard'
import SettingManagement from '@/components/RootDashboard/SettingManagement'
import MailHistoryList from '@/components/RootDashboard/MailHistoryList'
import UserGroupManagementView from '@/views/user/UserGroupManagementView'
import UserDocumentManagementView from '@/views/user/UserDocumentManagementView'
import UserTagManagementView from '@/views/user/UserTagManagementView'
import EnvironmentHelper from '@/helpers/EnvironmentHelper'
import {Paths} from '@/routes/paths.js'
import Home from '@/views/Home.vue'
import UserTagDocumentView from '@/views/user/UserTagDocumentView.vue'
import AdminGeneralStatistic from '@/views/admin/AdminGeneralStatistic.vue'
import UserGroupDocumentView from '@/views/user/UserGroupDocumentView.vue'
import AdminContentManagement from '@/views/admin/AdminContentManagement'

Vue.use(Router)

const groupRoute = [
  {
    path: Paths.GROUP_MANAGEMENT,
    component: MainLayout,
    props: { default: true, auth: true },
    children: [
      {
        path: Paths.GROUP_MANAGEMENT,
        name: RouteNames.GROUP_MANAGEMENT,
        component: UserGroupManagementView,
      },
      {
        path: Paths.GROUP_DETAIL(),
        component: UserGroupDocumentView,
      },
    ],
  },
]

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: MainLayout,
      meta: {
        requiresAuth: false,
      },
      children: [
        {
          path: Paths.HOMEPAGE,
          component: Home,
        },
        {
          path: Paths.LOGIN,
          component: Login,
        },
        { path: Paths.REGISTER, component: Register },
        {
          path: Paths.REGISTRATION_RESEND_ACTIVATION,
          component: ResendConfirmRegistration,
        },
        {
          path: Paths.REGISTRATION_CONFIRM_ACTIVATION,
          component: ConfirmRegistration,
        },
        {
          path: Paths.PASSWORD_FORGOT,
          component: ForgotPassword,
        },
        {
          path: Paths.PASSWORD_RESET,
          component: ResetPassword,
        },
      ],
    },
    {
      path: Paths.DOCUMENT_MANAGEMENT,
      component: MainLayout,
      props: { default: true, auth: true },
      children: [
        {
          path: Paths.DOCUMENT_MANAGEMENT,
          name: RouteNames.USER_DOCUMENTS_MANAGEMENT,
          component: UserDocumentManagementView,
        },
      ],
    },
    {
      path: Paths.TAG_MANAGEMENT,
      component: MainLayout,
      children: [
        {
          path: Paths.TAG_MANAGEMENT,
          name: RouteNames.TAG_MANAGEMENT,
          component: UserTagManagementView,
        },
      ],
    },
    {
      path: Paths.USER_PROFILE,
      component: MainLayout,
      children: [
        {
          path: Paths.USER_PROFILE,
          component: UserProfileView,
          children: [
            {
              path: Paths.USER_PROFILE_INFORMATION,
              component: UserInformation,
            },
            { path: Paths.USER_PROFILE_SECURITY, component: Security },
            { path: Paths.USER_PROFILE_API_KEY, component: KeyAPI },
          ],
        },
      ],
    },
    {
      path: Paths.DOCUMENT_RESULT_VIEW(),
      component: DocumentResultView,
    },
    {
      path: "/dashboard",
      component: MainLayout,
      children: [
        {
          path: "/",
          name: "dashboard",
          component: Dashboard,
          children: [
            {
              path: Paths.ADMIN_GENERAL_STATISTIC,
              component: AdminGeneralStatistic,
            },
            {
              path: Paths.ADMIN_DOCUMENTS,
              component: DocumentManagement,
            },
            {
              path: Paths.ADMIN_USERS,
              component: AdminUserManagement,
            },
            {
              path: Paths.ADMIN_CONTENTS,
              component: AdminContentManagement,
            },
          ],
        },
      ],
    },
    {
      path: "/root-dashboard",
      component: MainLayout,
      children: [
        {
          path: "/",
          name: "root-dashboard",
          component: RootDashboard,
          children: [
            {
              path: "/",
              name: "main-root-dashboard",
              component: SettingManagement,
            },
            {
              path: "setting",
              name: "setting_management",
              component: SettingManagement,
            },
            {
              path: "mail_history",
              name: "mail_history",
              component: MailHistoryList,
            },
          ],
        },
      ],
    },
    {
      path: Paths.TAG_DETAIL(),
      component: MainLayout,
      children: [
        {
          path: Paths.TAG_DETAIL(),
          component: UserTagDocumentView,
        },
      ],
    },
  ],
})

if (EnvironmentHelper.isEnable("VUE_APP_ENABLE_GROUP_CHECK")) {
  router.addRoutes(groupRoute)
}

export default router
